// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-content {
  display: list-item;
}
ion-content ion-searchbar {
  width: 87%;
}
ion-content .scroll-list ion-list {
  height: 100%;
}
ion-content ion-radio {
  --color: #ddd;
  --color-checked: var(--ion-color-tertiary);
}
ion-content ion-list {
  border-top-left-radius: 6px;
}
ion-content ion-list ion-item {
  cursor: pointer;
  height: 45px;
}
ion-content ion-list ion-item ion-icon {
  background: var(--ion-color-primary);
  border-radius: 8px;
  padding: 5px;
  color: #ffffff;
  width: 16px;
  height: 16px;
}
ion-content .delete {
  color: --ion-color-danger !important;
}`, "",{"version":3,"sources":["webpack://./src/modules/@boxx/shared-components/lib/custom-language-picker/custom-language-picker.page.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;AACJ;AACE;EAEE,UAAA;AAAJ;AAQI;EACE,YAAA;AANN;AAUE;EACE,aAAA;EACA,0CAAA;AARJ;AAWE;EACE,2BAAA;AATJ;AAWI;EACE,eAAA;EACA,YAAA;AATN;AAWM;EACE,oCAAA;EACA,kBAAA;EACA,YAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;AATR;AAcE;EACE,oCAAA;AAZJ","sourcesContent":["ion-content {\n    display: list-item;\n\n  ion-searchbar {\n    //width: 88%;\n    width: 87%;\n  }\n\n  .scroll-list{\n    // height: 150px;\n    // --offset-bottom: auto !important;\n    // overflow: auto;\n\n    ion-list{\n      height: 100%;\n    }\n  }\n\n  ion-radio {\n    --color: #ddd;\n    --color-checked: var(--ion-color-tertiary);\n  }\n\n  ion-list {\n    border-top-left-radius: 6px;\n\n    ion-item {\n      cursor: pointer;\n      height: 45px;\n\n      ion-icon {\n        background: var(--ion-color-primary);\n        border-radius: 8px;\n        padding: 5px;\n        color: #ffffff;\n        width: 16px;\n        height: 16px;\n      }\n    }\n  }\n\n  .delete {\n    color: (--ion-color-danger) !important;\n  }\n\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
